import { Button } from '@curtin-dxp/curtin-ui';
import {
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from '@/components';

interface AlertModalProps {
  title: string;
  description: string;
  confirmAction?: () => void;
  cancelAction?: () => void;
  open: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
}
export const AlertModal = ({
  title,
  description,
  confirmAction,
  cancelAction,
  open,
  confirmLabel,
  cancelLabel,
}: AlertModalProps) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="w-[635px] items-start gap-0 bg-white px-[36px] py-[34px] sm:rounded-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-[34px] font-bold leading-[50px]">{title}</AlertDialogTitle>
          <AlertDialogDescription className="py-8 font-proxima text-[18px] leading-[28px]">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-row gap-5 sm:justify-start">
          {confirmAction && (
            <Button
              variant="filled-primary"
              className="h-10 rounded-lg px-[30px] py-[15px] text-base font-semibold leading-6"
              onClick={confirmAction}
            >
              {confirmLabel || 'Confirm'}
            </Button>
          )}
          {cancelAction && (
            <Button
              variant="outline-secondary"
              className="h-10 rounded-lg border-deep-blue px-[30px] py-[15px] text-base font-semibold leading-6 text-deep-blue
                hover:border-deep-blue hover:bg-deep-blue"
              onClick={cancelAction}
            >
              {cancelLabel || 'Cancel'}
            </Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
